import React from "react";

const Footer = () => {
    return (
        <footer className="bg-rosegold text-white py-6">
            <div className="container mx-auto text-center">
                <p className="text-sm " style={{fontFamily:'Inria, serif'}}>&copy; {new Date().getFullYear()} Fatimah Zahra. All right reserved</p>
            </div>
        </footer>
    )
    
}

export default Footer